import { ChangeDetectionStrategy, Component, signal, ViewEncapsulation, WritableSignal } from '@angular/core';
import { PlycaUiButtonGenericComponent } from '../../../atoms/buttons/button-generic/button-generic.component';
import { PlycaUiDividerComponent } from '../../../atoms/divider/divider.component';
import { PlycaUiComparatorComponent } from '../comparator.component';
import { ComparatorDemoData } from './_config/comparator-demo.const';
import { ComparatorDemoModel } from './_config/comparator-demo.model';

@Component({
  selector: 'plyca-ui-comparator-demo',
  templateUrl: './comparator-demo.component.html',
  styleUrl: './comparator-demo.component.scss',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PlycaUiComparatorComponent, PlycaUiDividerComponent, PlycaUiButtonGenericComponent]
})
export class PlycaUiComparatorDemoComponent {
  public comparatorDataSig: WritableSignal<ComparatorDemoModel> = signal(ComparatorDemoData);

  public onClickDelete(item: any) {
    console.error('Delete', item);
  }

  public onClickAdd(item: any) {
    console.error('Add', item);
  }
}
